import {OperatingArea, OperatingAreaEntity} from "../../../model/operating-area";
import {createParamSelector, getUseQueryResultData} from "../../../util/selector-util";
import {createSelector} from "@reduxjs/toolkit";

export type OperatingAreaSelectorProps = {
  companyId?: string
  companyUnitId?: string
  regionId?: string
};

const getRegionIdParam = createParamSelector<OperatingAreaSelectorProps | undefined, string | undefined>(params => params?.regionId);
const getCompanyIdParam = createParamSelector<OperatingAreaSelectorProps | undefined, string | undefined>(params => params?.companyId);
const getCompanyUnitIdParam = createParamSelector<OperatingAreaSelectorProps | undefined, string | undefined>(params => params?.companyUnitId);

export const operatingAreaSelector = () => createSelector(
  [getUseQueryResultData<OperatingArea>],
  (data) => {
    return data ? transformOperatingArea(data) : undefined;
  }
);

export const operatingAreasSelector = () => createSelector(
  [getUseQueryResultData<OperatingArea[]>, getRegionIdParam, getCompanyIdParam, getCompanyUnitIdParam],
  (data, regionId, companyId, companyUnitId) => {
    return selectOperatingAreasAndTransform(
      data ?? [], {
        regionId: regionId,
        companyId: companyId,
        companyUnitId: companyUnitId,
      }
    );
  }
);

export const transformOperatingArea = (value: OperatingArea): OperatingAreaEntity => {
  return OperatingAreaEntity.from(value)
}

export const selectOperatingAreas = (values?: OperatingArea[], selector?: OperatingAreaSelectorProps): OperatingArea[] => {
  if (!values) {
    return [];
  }

  return values.filter((v) => {
    let filterIn = true;

    if (selector?.regionId) {
      if (selector.regionId !== v.regionId) {
        filterIn = false
      }
    }

    if (selector?.companyId) {
      if (selector.companyId !== v.companyId) {
        filterIn = false
      }
    }

    if (selector?.companyUnitId) {
      if (selector.companyUnitId !== v.companyUnitId) {
        filterIn = false
      }
    }

    return filterIn;
  });
};

export const selectOperatingAreasAndTransform = (values?: OperatingArea[], selector?: OperatingAreaSelectorProps): OperatingAreaEntity[] => {
  const selected = selectOperatingAreas(values, selector);
  return selected.map(transformOperatingArea);
};
